import React from "react";
import styled from "styled-components";

const BigTextStyled = styled.h4(
  ({ color, theme }) => `
    font-size: 18px;
    font-weight: 400;
    color: ${theme.colors[color] || theme.colors.black};
`
);

export const BigText = ({ color, children, styles, ...props }) => (
  <BigTextStyled color={color} style={styles} {...props}>
    {children}
  </BigTextStyled>
);
